
import { lrsStateType } from "../types/reducer";
import { lrsEventType, setUserInfoType } from "./types";
  
  
  export const RECORD_LRS_EVENT_SAGA = (payload: lrsEventType) => ({
    type: 'RECORD_LRS_EVENT_SAGA',
    payload: payload
  });  


  export const SET_LRS_STATE = (payload: lrsStateType) => ({
    type: 'SET_LRS_STATE',
    payload: payload
  });  


  export const RECORD_USER_LOGIN = (payload: setUserInfoType) => ({
    type: 'RECORD_USER_LOGIN',
    payload: payload
  });  


  

   
  
  
  